module.exports = __webpack_public_path__ + "static/media/webinar-emsd831.0ec553e6.jpeg";